import React, { useState } from 'react';
import { useAsync } from 'react-async';
import { getMyProfile } from '../../api/services/meService';
import Layout from '../../components/layout';
import User from '../../api/models/user';
import { hasValue } from '../../common/utils';
import { useHistory } from 'react-router-dom';
import { Role } from '../../common/constants';
import DefaultDashboard from '../../components/dashboards';

const DefaultDashboardPage = () => {
  const [user, setUser] = useState<User>();
  const history = useHistory();
  const asyncUser = useAsync({
    promiseFn: getMyProfile,
    onResolve: (response) => {
      const user: User = response.data.user;

      if (hasValue(user.userRoles) && user.userRoles.length > 0 && user.userRoles.some(x => x.role.name === Role.Admin || x.role.name === Role.SuperUser)) {
        history.push('/messages');
      }

      setUser(user);
    }
  });

  return (
    <Layout isLoading={asyncUser.isPending}>
      <>
        <DefaultDashboard user={user!} />
      </>
    </Layout>
  );
};

export default DefaultDashboardPage;
